<template>
  <CustomerForm
    :title="$t('customer.form.editTitle')"
    :submit-text="$t('customer.form.save')"
    :initial-data="initialData"
    :on-submit="handleUpdate"
    :load-data="loadData"
  />
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'

const { t } = useI18n()
import { getCustomerDetail, updateCustomer } from '@/api/customer'
import CustomerForm from '@/components/CustomerForm.vue'

const route = useRoute()
const router = useRouter()

const initialData = ref({})

const loadData = async () => {
  const id = route.params.id
  if (!id) return {}
  
  const response = await getCustomerDetail(id)
  const data = response.data
  initialData.value = {
    id: data.id || 0,
    name: data.name || '',
    phone: data.phone || '',
    gender: data.gender === true,
    age: data.age ?? 0,
    status: data.status ?? 0,
    remark: data.remark || '',
    avatar: data.avatar || '',
    isAdmin: data.isAdmin || false
  }
  return initialData.value
}

const handleUpdate = async (formData) => {
  const id = route.params.id
  const data = {
    ...formData,
    id: parseInt(id)
  }
  await updateCustomer(id, data)
  ElMessage.success(t('customer.editSuccess'))
  router.push('/customer')
}
</script>
